export default class OnThisPage {
    constructor(id: string) {
        const mainContent: HTMLElement = document.querySelector('main.content#main');
        const article: HTMLElement = mainContent.querySelector('article.col2');
        const headers: NodeListOf<HTMLHeadingElement> = article.querySelectorAll('h2:not(#on-this-page-title):not(.modal-section h2):not(.card__container h2), .h2');
        const onThisPage: HTMLElement = document.getElementById(id);
        const anchorList: HTMLUListElement = onThisPage.querySelector("ul");

        if (!headers || headers.length == 0) {
            anchorList.remove();
        }
        headers.forEach((header, index) => {
            const li: HTMLLIElement = document.createElement('li');
            const a: HTMLAnchorElement = document.createElement('a');

            if (!header.id) {
                header.id = 'anchor-link-' + (index + 1);
            }

            a.href = '#' + header.id;
            a.textContent = header.textContent;
            li.appendChild(a);
            anchorList.appendChild(li);
        });
    }
}
